// start:ng42.barrel
export * from './offer.service';
// end:ng42.barrel

